// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"bf_bv","reviews__wrapper__list":"bf_fn","reviewSlider":"bf_fp"};